<style lang="less" scoped>
@import '../../../style/common/variable';
.compSwiperImg {position: relative;margin: 0px;
.pic {position: absolute;left: 0px;width:100%;}
.box {position: absolute;left: 0px;bottom: 0px;height: 50px;width: 100%;background-color: rgba(58, 55, 55, 0.432);
.title {position: absolute;top: 15px;left: 18px;z-index: 1;width: 92%;font-size: 18px;letter-spacing: 2px;color: white;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;}}}
.swiper-slide{background-color: rgb(146, 200, 250); cursor: pointer;}
@media screen and (max-width: @max-screen){
  .swiper-container{width: 100vw !important;height: 2.5rem !important;}
}
</style>

<!--何宽  2021.6.2
    该轮播组件使用场景：自动轮播图片及对应的标题信息。点击swiper图片或标题，将 整个图片标题对象 传递给父组件 -->
<template>
  <div class="compSwiperImg">
    <div class="swiper-container" :style="{width:this.widthCSH+'px',height:this.heightCSH+'px'}">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in swiperlist" :key="index" @click="clickSwiper(item)">
          <img class="pic" :src="item.pic" />
          <div class="box">
            <span class="title"> {{ item.title }} </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'
export default {
  props: ['widthCSH', 'heightCSH', 'swiperlist'],
  data()
  {
    return {}
  },
  updated()
  {
    // eslint-disable-next-line
    const swiper = new Swiper('.swiper-container', {
      direction: 'horizontal',
      loop: true,
      autoplay: true,
      speed: 800
    })
  },
  methods: {
    // 点击轮播内容，将 Swiper对象 传递给父组件
    clickSwiper(item)
    {
      this.$emit('clickSwiper', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/SwiperImg.vue